import React, { useState } from 'react';
import TimeSlot from './time_slot';
import DailyShiftPreviewTable from './daily_shift_preview_table';



export function AddDailyWorkingHour({ selectedDay, shiftData, onShiftDeleted, onShiftAdded, onSaveDailyWorkingHour, allowHiddenBreaks, onAssignWh }) {
  const [showTimeSlot, setShowTimeSlot] = useState(true);
  const [error, setError] = useState('');
  const [shiftPreviews, setShiftPreviews] = useState(shiftData || []);
  const [showAddTimeSlotButton, setShowAddTimeSlotButton] = useState(true);
  const isAssignWh = onAssignWh === 'assignWhComponent';

  const toMinutes = (time) => {
    if (!time) return null;
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  };

  
  const checkIt = (previewData, indexToExclude = null) => {
    const candStartMin = toMinutes(previewData.workStartTime);
    const candEndRawMin = toMinutes(previewData.workEndTime);
    if (candStartMin == null || candEndRawMin == null) return false;

    const candCrossesMidnight =
      isAssignWh && candEndRawMin < candStartMin;

    // Per il giorno corrente consideriamo al massimo le 24:00
    const candEndMin = candCrossesMidnight ? 24 * 60 : candEndRawMin;

    return shiftPreviews.some((preview, index) => {
      if (index === indexToExclude) return false;
      if (!preview.workStartTime || !preview.workEndTime) return false;

      const prevStartMin = toMinutes(preview.workStartTime);
      const prevEndRawMin = toMinutes(preview.workEndTime);
      if (prevStartMin == null || prevEndRawMin == null) return false;

      const prevCrossesMidnight =
        isAssignWh && prevEndRawMin < prevStartMin;

      const prevEndMin = prevCrossesMidnight ? 24 * 60 : prevEndRawMin;

      // Overlap classico tra [start, end) e [candStart, candEnd)
      const overlap =
        candStartMin < prevEndMin && candEndMin > prevStartMin;

      return overlap;
    });
  };

  const handleShiftPreview = (previewData, index = null) => {
    if (checkIt(previewData, index)) {
      setError("La nuova fascia oraria si sovrappone ad un orario già inserito.");
      return;
    }
  
    const updatedPreviews = [...shiftPreviews];
  
    if (index !== null) {
      updatedPreviews[index] = previewData;
    } else {
      updatedPreviews.push(previewData);
    }
  
    setShiftPreviews(updatedPreviews);
    setShowTimeSlot(false);
    setError('');

    if(selectedDay && onShiftAdded) {
      onShiftAdded(previewData);
    }
  };

  const handleDeleteShift = (index) => {
    const updatedPreviews = [...shiftPreviews];
    updatedPreviews.splice(index, 1);
    if(onShiftDeleted)
      onShiftDeleted(selectedDay || '', index)
    setShiftPreviews(updatedPreviews);
  };

  const handleHideTimeSlot = () => {
    setShowTimeSlot(false);
    setError('');
  };

  const handleAddNewSlotClick = () => {
    setShowTimeSlot(true);
    setError('');
  };

  const handleSave = () => {
    if (onSaveDailyWorkingHour) {
      onSaveDailyWorkingHour(shiftPreviews);     
    }
  };

  return (
    <div>
      <DailyShiftPreviewTable 
        shiftPreviews={shiftPreviews} 
        onShiftPreview={handleShiftPreview} 
        onDeleteShift={handleDeleteShift}
        allowHiddenBreaks={allowHiddenBreaks} 
        onAssignWh={onAssignWh}
      />

      {error && (
        <div className="my-2 mx-4 flex justify-center">
          <p className="text-red-500 text-sm">{error}</p>
        </div>
      )}
      {showTimeSlot && (
        <TimeSlot
          onShiftPreview={handleShiftPreview}
          onCancelEdit={handleHideTimeSlot}
          allowHiddenBreaks={allowHiddenBreaks}
          onAssignWh={onAssignWh}
        />
      )}
      <div className="flex justify-center my-4 mx-4">
        <div className="grid sm:grid-cols-1 md:grid-cols-2 md:justify-between justify-center">
          {!showTimeSlot && showAddTimeSlotButton && (
            <button 
              onClick={handleAddNewSlotClick} 
              className="uppercase px-4 py-2 mb-2 md:mr-2 sm:mr-0 rounded-md font-semibold text-sm bg-white border border-solid-2 border-gray-200 shadow-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-white"
            >
              Aggiungi Fascia Oraria
            </button>
          )}

          {shiftPreviews.length > 0 && (
            <button
              onClick={handleSave}
              className="uppercase px-4 mb-2 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-white bg-indigo-600 font-semibold text-white text-sm shadow-md"
            >
              Salva
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
